import {ButtonType} from './Button';
import {COLORS} from '../../../constants/colors';

export const getBackgroundColor = (type?: ButtonType) => {
  switch (type) {
    case 'primary':
      return COLORS.Black;

    case 'secondary':
      return COLORS.White;

    default:
      return COLORS.Black;
  }
};

export const getFontColor = (type?: ButtonType) => {
  switch (type) {
    case 'primary':
      return COLORS.White;

    case 'secondary':
      return COLORS.Black;

    default:
      return COLORS.White;
  }
};
